// extracted by mini-css-extract-plugin
module.exports = {"container":"virtualAssistantPage_container__2oSzb","summaryContainer":"virtualAssistantPage_summaryContainer__3st_X"};
    if(module.hot) {
      // 1790670286956
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  